import { useTranslation } from 'react-i18next'
import { TextField, Button, MenuItem } from '@mui/material'

import { config } from '../../config'
import { FormError, SystemUser } from '../../types'
import { textFieldWhiteBg, baseButtonBlueBg, baseButtonWhiteBg } from '../../theme/custom-styles'

const ProfileForm = ({
  errors,
  systemUserData,
  handleUpdateProfileData,
  handleSetSystemUserData,
  systemUserDataInitialState,
  handleOpenChangePasswordModal
}: {
  errors: FormError
  handleUpdateProfileData: () => void
  systemUserData: Partial<SystemUser>
  handleOpenChangePasswordModal: () => void
  systemUserDataInitialState: Partial<SystemUser>
  handleSetSystemUserData: (systemUserDataUpdated: Partial<SystemUser>) => void
}) => {
  const { t, i18n } = useTranslation(['account-management'])

  return (
    <div className="account-management-profile-form">
      <div className="account-management-profile-form-row">
        <div className="account-management-profile-form-field-container">
          <TextField
            fullWidth
            variant="standard"
            sx={textFieldWhiteBg}
            label={t('profileForm.fields.firstName')}
            error={!!errors.firstName}
            helperText={errors.firstName}
            value={systemUserData.firstName || ''}
            onChange={(event) => {
              const systemUserDataUpdated = {
                ...systemUserData,
                firstName: event.target.value.toUpperCase()
              }

              handleSetSystemUserData(systemUserDataUpdated)
            }}
          />
        </div>
        <div className="account-management-profile-form-field-container">
          <TextField
            fullWidth
            variant="standard"
            sx={textFieldWhiteBg}
            label={t('profileForm.fields.lastName')}
            error={!!errors.lastName}
            helperText={errors.lastName}
            value={systemUserData.lastName || ''}
            onChange={(event) => {
              const systemUserDataToSet = {
                ...systemUserData,
                lastName: event.target.value.toUpperCase()
              }

              handleSetSystemUserData(systemUserDataToSet)
            }}
          />
        </div>
      </div>
      <div className="account-management-profile-form-row">
        <div className="account-management-profile-form-field-container">
          <TextField
            fullWidth
            disabled
            variant="standard"
            sx={textFieldWhiteBg}
            label={t('profileForm.fields.email')}
            error={!!errors.username}
            helperText={errors.username}
            value={systemUserData.username || ''}
          />
        </div>
        <div className="account-management-profile-form-field-container">
          <div className="account-management-profile-form-password-field-container">
            <TextField
              fullWidth
              disabled
              type="password"
              variant="standard"
              sx={textFieldWhiteBg}
              label={t('profileForm.fields.password')}
              error={!!errors.username}
              helperText={errors.username}
              value="1234567890"
            />
          </div>
          <div className="account-management-profile-form-password-button-container">
            <Button
              variant="contained"
              sx={baseButtonBlueBg}
              onClick={handleOpenChangePasswordModal}
            >
              <div className="account-management-profile-form-password-button-text">{t('profileForm.buttonText.changePassword')}</div>
            </Button>
          </div>
        </div>
      </div>
      <div className="account-management-system-settings-form-container">
        <div className="account-management-section-header">{t('sectionConfigTitle')}</div>
        <div className="account-management-profile-form-config-field-row">
          <div className="account-management-profile-form-system-config-field-container">
            <TextField
              select
              fullWidth
              variant="standard"
              label={t('profileForm.fields.systemConfiguration.preferredLanguage')}
              sx={{ ...textFieldWhiteBg, '& .MuiInputBase-root .MuiSelect-select': { height: '2.7em', boxSizing: 'border-box', padding: '12px 16px 4px' } }}
              value={i18n.language === 'es-ES' || i18n.language === 'es' ? 'spanish' : 'english'}
              onChange={(event) => {
                if (event.target.value === 'spanish') {
                  i18n.changeLanguage('es').then(() => {
                    window.location.reload();  
                  });
                  return;
                }
              
                i18n.changeLanguage('en').then(() => {
                  window.location.reload();  
                });
              }}
            >
              <MenuItem value="spanish">Español</MenuItem>
              <MenuItem value="english">English</MenuItem>
            </TextField>
          </div>
          <div className="account-management-profile-form-system-config-field-container">
            <TextField
              fullWidth
              disabled
              variant="standard"
              sx={textFieldWhiteBg}
              value={config.app.version}
              label={t('profileForm.fields.systemConfiguration.version')}
            />
          </div>
        </div>
      </div>
      <div className="account-management-profile-form-button">
        <Button
          variant="contained"
          sx={baseButtonWhiteBg}
          onClick={handleUpdateProfileData}
          disabled={JSON.stringify(systemUserData) === JSON.stringify(systemUserDataInitialState)}
        >
          {t('profileForm.buttonText.saveChanges')}
        </Button>
      </div>
    </div>
  )
}

export default ProfileForm
